import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from 'src/common';
import { selectBenchmarks } from 'src/features/clients/client/performance/store/selectors';
import { fetchBenchmarks } from 'src/features/clients/client/performance/store/thunks';
import { newReportsSlice } from 'src/features/clients/client/reportsV2/store/slice';
import { downloadReport } from 'src/features/clients/client/reportsV2/store/thunks';
import { RootState } from 'src/reducers';
import { selectHasClientEditAdminOnly } from 'src/store/selectors';
import { selectReportingBatch } from '../store/selectors';
import { ReportingBatchComponent } from './components/ReportingBatchComponent';
import { reportingBatchSlice } from './store/slice';
import {
  approveScheduledInstance,
  downloadBatchRecordsCsv,
  downloadBulkReports,
  fetchBulkProgress,
  fetchBulkReport,
  fetchBulkReportLogList,
  fetchBulkReportRecordList,
  fetchGroupReport,
  initiateBulkRequest,
  ReportingBatchActionTypes,
  reviewScheduledInstanceRecord,
  terminateBulkRequest,
} from './store/thunks';

const mapStateToProps = (state: RootState) => ({
  ...reportingBatchSlice.reducer,
  batch: selectReportingBatch(state),
  benchmarks: selectBenchmarks(state),
  hasClientEditAdminOnly: selectHasClientEditAdminOnly(state),
  initiateBulkRequestProgress: progressSelectorFactory([ReportingBatchActionTypes.InitiateBulkRequest])(state),
  fetchBulkReportProgress: progressSelectorFactory([ReportingBatchActionTypes.FetchBulkReport])(state),
  fetchBulkReportLogListProgress: progressSelectorFactory([ReportingBatchActionTypes.FetchBulkReportLogList])(state),
  fetchBulkReportRecordListProgress: progressSelectorFactory([ReportingBatchActionTypes.FetchBulkReportRecordList])(state),
  terminateBulkRequestProgress: progressSelectorFactory([ReportingBatchActionTypes.TerminateBulkRequest])(state),
  reviewScheduledInstanceRecordProgress: progressSelectorFactory([ReportingBatchActionTypes.ReviewScheduledInstanceRecord])(state),
  approveScheduledInstanceProgress: progressSelectorFactory([ReportingBatchActionTypes.ApproveScheduledInstance])(state),
});

const mapDispatchToProps = {
  ...newReportsSlice.actions,
  initiateBulkRequest,
  fetchBenchmarks,
  fetchBulkProgress,
  fetchBulkReportLogList,
  fetchBulkReportRecordList,
  reviewScheduledInstanceRecord,
  downloadReport,
  approveScheduledInstance,
  terminateBulkRequest,
  fetchBulkReport,
  downloadBulkReports,
  fetchGroupReport,
  downloadBatchRecordsCsv,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const ReportingBatchContainer = connector(ReportingBatchComponent);
